<div>
  <div class="step-title-container">{{'' | i18n: 'dealer-communication'}}</div>
  <div class="message-body" id="message-body">
    @for (message of messages; track message) {
      <div [ngClass]="message.admin ? 'admin-message' : 'user-message' ">
        <div>
          @if (message.admin) {
            <span class="user">
              {{'' | i18n: 'dealer-communication-admin'}}
            </span>
          }
          @if (!message.admin) {
            <span class="user">
              {{'' | i18n: 'dealer-communication-dealer'}}
            </span>
          }
          @if (message.supportingMaterialFilePath == '') {
            <span id="messageText">
              {{message.message}}
            </span>
          }
          @if (message.supportingMaterialFilePath != '') {
            <span id="messageText">
              <a (click)="getSupportingDocument(message)" id="downloadReviewDoc">{{message.message}}</a>
            </span>
          }
          <span id="receivedTime">
            {{formatDate(message.receivedTime)}}
          </span>
        </div>
      </div>
    }
  </div>
  @if (showDealerCorrectionText()) {
    <div class="message-input-container" id="message-input-container">
      <input type="file" class="input-border" id="files" #files (change)="selectSupportingDocument(files.files)"
        accept=".csv, .pdf, .docx, .jpg, .png, .eml, .odt, .msg, .htm">
        <label for="files">{{'' | i18n: 'select-file'}}</label>
        <textarea
          class="message-input cx-input i18n cx-form-control cx-disabled"
          id="messageInput" maxlength="500"
          data-message="ChatInputPlaceholder"
          data-message-type="placeholder"
          aria-label="Type your message here."
          placeholder="{{'' | i18n: 'Type-your-message-here'}}"
          tabindex="-1"
        aria-hidden="true"></textarea>
        <div class="cx-send cx-icon i18n" data-icon="send" class="sendButton" role="button" data-message="ChatInputSend" data-message-type="title" tabindex="0" aria-label="Send" title="Send" (click)="postMessage();">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" viewBox="0 0 100 100" focusable="false" role="img" aria-hidden="true" alt="">
            <path class="cx-svg-icon-tone1"
              d="M98.7,39.7L2.9,0.2C2.1-0.2,1.1,0,0.5,0.7c-0.6,0.7-0.7,1.6-0.2,2.4l22.9,39.6c0.4,0.6,1.1,1,1.8,1h50v-4.2H26.2L7,6.4l85.5,35.3l-84.8,35l17-25.6l-3.5-2.3L0.4,80.1c-0.5,0.8-0.5,1.8,0.1,2.5c0.4,0.5,1,0.8,1.6,0.8c0.3,0,0.5-0.1,0.8-0.2l95.8-39.6c0.8-0.3,1.3-1.1,1.3-1.9S99.5,40.1,98.7,39.7z">
            </path>
          </svg>
        </div>
      </div>
    }
  </div>
